import axios from "axios";
import url from "../../services/url";

export default async function locations() {
  try {
    const response = await axios.get(url("location/formLocation"), {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user.token")}`,
      },
    });
    return response?.data?.locationMaster
  } catch {}
}
